import React from 'react';
import { Reveal } from './Reveal';
export function FooterCta() {
  return <section className="bg-ink py-12 px-6 text-center" data-id="element-81">
      <Reveal data-id="element-82">
        <h2 className="font-serif text-[32px] font-light italic text-white leading-[1.3] mb-6" data-id="element-83">
          Tu cuerpo lleva tiempo
          <br data-id="element-84" />
          pidiéndote atención.
        </h2>
        <a href="https://www.soportesaberdigital.com/cart/49527567057135:1" target="_blank" rel="noopener noreferrer" className="btn-buy inline-flex items-center justify-center gap-2 w-full max-w-full bg-gradient-to-br from-terra to-[#D4693F] text-white font-sans text-[16px] font-bold py-5 px-8 rounded-xl no-underline tracking-[0.01em] transition-all duration-150 relative overflow-hidden" data-id="element-85">
          <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none" data-id="element-86"></div>
          Empezá hoy — $24.990
        </a>
        <p className="text-[11px] text-white/25 mt-6 leading-[1.6]" data-id="element-87">
          Información educativa. No reemplaza la consulta médica profesional.
          <br data-id="element-88" />© Código Hormonal · Todos los derechos reservados.
        </p>
      </Reveal>
    </section>;
}